import axios from "axios";
import { ENDPOINTS, getBaseURL } from "data/endpoints";
import { getHeaders } from "data/headers";

export const userDetailsApi = () => {
  return axios.get(getBaseURL() + ENDPOINTS.USER_DETAILS, {
    headers: getHeaders(),
  });
};
